import {ResourceLoader} from '../utils/ResourceLoader'
import {Base} from './Base'
import {LatLon} from '../models/LatLon'

export class Mapbox extends Base {
  public config: any

  public loadResources() {
    return [
      ResourceLoader('script', 'mapbox-map', 'https://api.mapbox.com/mapbox-gl-js/v1.8.1/mapbox-gl.js'),
      ResourceLoader('css', 'mapbox-map', 'https://api.mapbox.com/mapbox-gl-js/v1.8.1/mapbox-gl.css'),
    ]
  }

  public initMap(element: HTMLElement, initConfig: any, s: any): void {
    // Classic way: mapboxgl.accessToken = this.config.apiKey
    // @ts-ignore
    this.map = new mapboxgl.Map({
      container: element,
      style: this.config.style,
      accessToken: this.config.apiKey,
      center: [initConfig.center.lng, initConfig.center.lat],
      zoom: initConfig.zoom
    })
    s()
    // https://www.mapbox.com/install/js/cdn-complete/
  }

  public setClickListener(l: (p: LatLon) => void): void {
    this.map.on('click', (evt: any) => {
      l(new LatLon(evt.lngLat.lat, evt.lngLat.lng))
    })
  }

  public pan(p: LatLon): void {
    this.map.flyTo({
      center: [p.longitude, p.latitude],
    })
  }

  public destroy(): void {
    this.map.remove()
    delete this.map
  }
}
